// src/components/Navbar.js
import { NavLink } from 'react-router-dom';
import { useSiteConfig } from '../hooks/useSiteConfig';
import '../App.css';

function Navbar() {
  const { config } = useSiteConfig();

  return (
    <nav id="navbar" className="navbar">
      <img id="navbar-logo" className="navbar-logo" src={config.logoUrl || '/logo.png'} alt="CSdevs logo" />
      <ul id="navbar-links" className="navbar-links">
        <li id="nav-home"><NavLink to="/" end>Home</NavLink></li>
        <li id="nav-portfolio"><NavLink to="/portfolio">Portfolio</NavLink></li>
        <li id="nav-services"><NavLink to="/services">Services</NavLink></li>
        <li id="nav-about"><NavLink to="/about">About</NavLink></li>
        <li id="nav-contact"><NavLink to="/contact">Contact</NavLink></li>
      </ul>
    </nav>
  );
}

export default Navbar;
